<div [class]="'col' + (!props.readonly && props.editFieldStyleClass ? ' ' + props.editFieldStyleClass : '')">
  <new-ui-autocomplete
    [formControl]="$any(formControl)"
    [formlyAttributes]="field"
    [label]="props.label"
    [readonly]="props.readonly || props.disabled"
    [required]="props.required"
    [multiple]="true"
    [typeahead]="false"
    [showClear]="props.showClear ?? true"
    [dt]="props.dt"
  />

  @if (!props.readonly && props.hint) {
    <p-message [dt]="props.dt?.components?.message" severity="info" variant="simple" size="small">
      {{ props.hint }}
    </p-message>
  }

  @if (showError) {
    <p-message [dt]="props.dt?.components?.message" severity="error" variant="simple" size="small">
      <formly-validation-message [field]="field" />
    </p-message>
  }
</div>
